(() => {
  const configScript = document.currentScript;
  if (!(configScript instanceof HTMLScriptElement)) return;

  /** @type {Map<string, Promise<HTMLScriptElement>>} */
  const loaded = new Map();
  /**
   * @param {string} src
   * @returns {Promise<HTMLScriptElement>}
   */
  function loadScriptOnce(src) {
    if (!src) return Promise.reject(new Error('Missing script URL'));
    if (loaded.has(src)) return /** @type {Promise<HTMLScriptElement>} */ (loaded.get(src));

    const existing = document.querySelector(`script[src="${CSS.escape(src)}"]`);
    if (existing instanceof HTMLScriptElement) return Promise.resolve(existing);

    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = () => resolve(script);
      script.onerror = () => reject(new Error(`Unable to load ${src}`));
      document.head.append(script);
    });
    loaded.set(src, promise);
    return promise;
  }

  const footer = document.querySelector('footer');
  const formsSrc = configScript.getAttribute('data-forms-src');
  if (footer && formsSrc && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        loadScriptOnce(formsSrc || '').catch(() => {});
      },
      { rootMargin: '500px 0px' }
    );
    observer.observe(footer);
  }
})();
